import { CSSProperties } from "react"
import cn from "classnames"

export function fieldClass(className: string, hasError?: boolean): string {
  return cn("FormField", className, {
    "FormField-error": hasError,
  })
}

export interface StyledProps {
  maxWidth?: string
}

export function fieldStyle(props: StyledProps): CSSProperties {
  const style: CSSProperties = {}
  if (props.maxWidth) style.maxWidth = props.maxWidth
  return style
}

export function identity(value: null | number | string): null | number | string {
  return value
}
